/**
 * HubMessage.Api
 * Simplified wrapper API for connecting with the hub service.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { Conversation } from '../model/conversation';
import { ConversationQuery } from '../model/conversationQuery';
import { ConversationStatus } from '../model/conversationStatus';
import { Message } from '../model/message';
import { MessageNotification } from '../model/messageNotification';
import { MostRecentMessagesRequest } from '../model/mostRecentMessagesRequest';
import { MostRecentMessagesResponse } from '../model/mostRecentMessagesResponse';
import { OldMessagesRequest } from '../model/oldMessagesRequest';
import { ReadReceipt } from '../model/readReceipt';
import { SearchNotificationsRequest } from '../model/searchNotificationsRequest';
import { UnreadMessageRequest } from '../model/unreadMessageRequest';
import { UpdateConversationMembersRequest } from '../model/updateConversationMembersRequest';
import { UpdateConversationMembersResponse } from '../model/updateConversationMembersResponse';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class ConversationService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   *
   * @param userId
   * @param filterByUserId
   * @param conversationId
   * @param conversationIds
   * @param statuses
   * @param applicationId
   * @param attributes
   * @param attributesAsString
   * @param startDate
   * @param endDate
   * @param optionsIncludeLatestMessage
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v1ConversationGet(
    userId?: string,
    filterByUserId?: boolean,
    conversationId?: number,
    conversationIds?: Array<number>,
    statuses?: Array<ConversationStatus>,
    applicationId?: number,
    attributes?: { [key: string]: Array<string> },
    attributesAsString?: string,
    startDate?: Date,
    endDate?: Date,
    optionsIncludeLatestMessage?: boolean,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public v1ConversationGet(
    userId?: string,
    filterByUserId?: boolean,
    conversationId?: number,
    conversationIds?: Array<number>,
    statuses?: Array<ConversationStatus>,
    applicationId?: number,
    attributes?: { [key: string]: Array<string> },
    attributesAsString?: string,
    startDate?: Date,
    endDate?: Date,
    optionsIncludeLatestMessage?: boolean,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public v1ConversationGet(
    userId?: string,
    filterByUserId?: boolean,
    conversationId?: number,
    conversationIds?: Array<number>,
    statuses?: Array<ConversationStatus>,
    applicationId?: number,
    attributes?: { [key: string]: Array<string> },
    attributesAsString?: string,
    startDate?: Date,
    endDate?: Date,
    optionsIncludeLatestMessage?: boolean,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public v1ConversationGet(
    userId?: string,
    filterByUserId?: boolean,
    conversationId?: number,
    conversationIds?: Array<number>,
    statuses?: Array<ConversationStatus>,
    applicationId?: number,
    attributes?: { [key: string]: Array<string> },
    attributesAsString?: string,
    startDate?: Date,
    endDate?: Date,
    optionsIncludeLatestMessage?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (userId !== undefined && userId !== null) {
      queryParameters = queryParameters.set('UserId', <any>userId);
    }
    if (filterByUserId !== undefined && filterByUserId !== null) {
      queryParameters = queryParameters.set('FilterByUserId', <any>filterByUserId);
    }
    if (conversationId !== undefined && conversationId !== null) {
      queryParameters = queryParameters.set('ConversationId', <any>conversationId);
    }
    if (conversationIds) {
      conversationIds.forEach((element) => {
        queryParameters = queryParameters.append('ConversationIds', <any>element);
      });
    }
    if (statuses) {
      statuses.forEach((element) => {
        queryParameters = queryParameters.append('Statuses', <any>element);
      });
    }
    if (applicationId !== undefined && applicationId !== null) {
      queryParameters = queryParameters.set('ApplicationId', <any>applicationId);
    }
    if (attributes !== undefined && attributes !== null) {
      queryParameters = queryParameters.set('Attributes', <any>attributes);
    }
    if (attributesAsString !== undefined && attributesAsString !== null) {
      queryParameters = queryParameters.set('AttributesAsString', <any>attributesAsString);
    }
    if (startDate !== undefined && startDate !== null) {
      queryParameters = queryParameters.set('StartDate', <any>startDate.toISOString());
    }
    if (endDate !== undefined && endDate !== null) {
      queryParameters = queryParameters.set('EndDate', <any>endDate.toISOString());
    }
    if (optionsIncludeLatestMessage !== undefined && optionsIncludeLatestMessage !== null) {
      queryParameters = queryParameters.set('Options.IncludeLatestMessage', <any>optionsIncludeLatestMessage);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<any>('get', `${this.basePath}/v1/Conversation`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v1ConversationPost(body?: Conversation, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public v1ConversationPost(body?: Conversation, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public v1ConversationPost(body?: Conversation, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public v1ConversationPost(body?: Conversation, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>('post', `${this.basePath}/v1/Conversation`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param conversationId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v1ConversationPut(conversationId?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public v1ConversationPut(conversationId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public v1ConversationPut(conversationId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public v1ConversationPut(conversationId?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (conversationId !== undefined && conversationId !== null) {
      queryParameters = queryParameters.set('conversationId', <any>conversationId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<any>('put', `${this.basePath}/v1/Conversation`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationGetOldMessagesPost(
    body?: OldMessagesRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<Message>>;
  public v2ConversationGetOldMessagesPost(
    body?: OldMessagesRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Message>>>;
  public v2ConversationGetOldMessagesPost(
    body?: OldMessagesRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Message>>>;
  public v2ConversationGetOldMessagesPost(
    body?: OldMessagesRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<Message>>('post', `${this.basePath}/v2/Conversation/GetOldMessages`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationJoinPost(body?: Array<Conversation>, observe?: 'body', reportProgress?: boolean): Observable<Array<Conversation>>;
  public v2ConversationJoinPost(
    body?: Array<Conversation>,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Conversation>>>;
  public v2ConversationJoinPost(
    body?: Array<Conversation>,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Conversation>>>;
  public v2ConversationJoinPost(body?: Array<Conversation>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<Conversation>>('post', `${this.basePath}/v2/Conversation/Join`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationMarkAllAsReadPost(body?: ReadReceipt, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
  public v2ConversationMarkAllAsReadPost(
    body?: ReadReceipt,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<boolean>>;
  public v2ConversationMarkAllAsReadPost(body?: ReadReceipt, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
  public v2ConversationMarkAllAsReadPost(body?: ReadReceipt, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<boolean>('post', `${this.basePath}/v2/Conversation/MarkAllAsRead`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationMostRecentPost(
    body?: MostRecentMessagesRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<MostRecentMessagesResponse>;
  public v2ConversationMostRecentPost(
    body?: MostRecentMessagesRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<MostRecentMessagesResponse>>;
  public v2ConversationMostRecentPost(
    body?: MostRecentMessagesRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<MostRecentMessagesResponse>>;
  public v2ConversationMostRecentPost(
    body?: MostRecentMessagesRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<MostRecentMessagesResponse>('post', `${this.basePath}/v2/Conversation/MostRecent`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationSearchManyPost(
    body?: Array<ConversationQuery>,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<Conversation>>;
  public v2ConversationSearchManyPost(
    body?: Array<ConversationQuery>,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Conversation>>>;
  public v2ConversationSearchManyPost(
    body?: Array<ConversationQuery>,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Conversation>>>;
  public v2ConversationSearchManyPost(
    body?: Array<ConversationQuery>,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<Conversation>>('post', `${this.basePath}/v2/Conversation/SearchMany`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationSearchNotificationsManyPost(
    body?: Array<SearchNotificationsRequest>,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<MessageNotification>>;
  public v2ConversationSearchNotificationsManyPost(
    body?: Array<SearchNotificationsRequest>,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<MessageNotification>>>;
  public v2ConversationSearchNotificationsManyPost(
    body?: Array<SearchNotificationsRequest>,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<MessageNotification>>>;
  public v2ConversationSearchNotificationsManyPost(
    body?: Array<SearchNotificationsRequest>,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<MessageNotification>>('post', `${this.basePath}/v2/Conversation/SearchNotificationsMany`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationSearchNotificationsPost(
    body?: SearchNotificationsRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<MessageNotification>>;
  public v2ConversationSearchNotificationsPost(
    body?: SearchNotificationsRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<MessageNotification>>>;
  public v2ConversationSearchNotificationsPost(
    body?: SearchNotificationsRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<MessageNotification>>>;
  public v2ConversationSearchNotificationsPost(
    body?: SearchNotificationsRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<MessageNotification>>('post', `${this.basePath}/v2/Conversation/SearchNotifications`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationSearchPost(body?: ConversationQuery, observe?: 'body', reportProgress?: boolean): Observable<Array<Conversation>>;
  public v2ConversationSearchPost(
    body?: ConversationQuery,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Conversation>>>;
  public v2ConversationSearchPost(
    body?: ConversationQuery,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Conversation>>>;
  public v2ConversationSearchPost(body?: ConversationQuery, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<Conversation>>('post', `${this.basePath}/v2/Conversation/Search`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationUnreadPost(body?: UnreadMessageRequest, observe?: 'body', reportProgress?: boolean): Observable<Array<Message>>;
  public v2ConversationUnreadPost(
    body?: UnreadMessageRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Message>>>;
  public v2ConversationUnreadPost(
    body?: UnreadMessageRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Message>>>;
  public v2ConversationUnreadPost(body?: UnreadMessageRequest, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<Message>>('post', `${this.basePath}/v2/Conversation/Unread`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public v2ConversationUpdateConversationMembersPost(
    body?: UpdateConversationMembersRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<UpdateConversationMembersResponse>;
  public v2ConversationUpdateConversationMembersPost(
    body?: UpdateConversationMembersRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<UpdateConversationMembersResponse>>;
  public v2ConversationUpdateConversationMembersPost(
    body?: UpdateConversationMembersRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<UpdateConversationMembersResponse>>;
  public v2ConversationUpdateConversationMembersPost(
    body?: UpdateConversationMembersRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<UpdateConversationMembersResponse>(
      'post',
      `${this.basePath}/v2/Conversation/UpdateConversationMembers`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
